// Mock data for FlirtyLive

export const mockGifts = [
  { id: 'rose', name: 'Rose', emoji: '\u{1F339}', cost: 10 },
  { id: 'heart', name: 'Heart', emoji: '\u{2764}\u{FE0F}', cost: 20 },
  { id: 'fire', name: 'Fire', emoji: '\u{1F525}', cost: 30 },
  { id: 'diamond', name: 'Diamond', emoji: '\u{1F48E}', cost: 50 },
  { id: 'crown', name: 'Crown', emoji: '\u{1F451}', cost: 100 },
  { id: 'kiss', name: 'Kiss', emoji: '\u{1F48B}', cost: 25 },
  { id: 'star', name: 'Star', emoji: '\u{2B50}', cost: 15 },
  { id: 'champagne', name: 'Champagne', emoji: '\u{1F37E}', cost: 75 },
];

export const hotSeatQuestions = [
  "What's the most romantic thing someone has done for you?",
  "What's your biggest turn-on?",
  "Have you ever had a secret crush on a friend?",
  "What's the boldest move you've ever made on a date?",
  "What's your idea of a perfect first date?",
  "What's the cheesiest pick-up line that actually worked on you?",
  "What's your guilty pleasure?",
  "Would you rather have a wild fling or a slow burn romance?",
  "What's the most spontaneous thing you've done for love?",
  "What quality do you find irresistible in someone?",
];

export const redFlagGreenFlagScenarios = [
  "They text you 'good morning' every single day",
  "They follow all your exes on social media",
  "They plan surprise dates without telling you where",
  "They want to meet your parents after the second date",
  "They remember every little detail you've mentioned",
  "They still have their ex's photos on Instagram",
  "They cook dinner for you after a long day",
  "They check your phone when you're not looking",
  "They introduce you to their friend group early on",
  "They cancel plans with friends to hang out with you",
];

export const truthQuestions = [
  "What's the most embarrassing thing you've done on a date?",
  "Have you ever sent a text to the wrong person? What did it say?",
  "What's the biggest lie you've told on a dating app?",
  "What's your most unpopular dating opinion?",
  "Have you ever been caught checking someone out?",
];

export const darePrompts = [
  "Do your best flirty face for 10 seconds",
  "Tell the person to your left a cheesy compliment",
  "Share the last selfie on your phone",
  "Sing a few lines of a love song",
  "Do an impression of someone in the room",
];

export const reactionEmojis = ['\u{2764}\u{FE0F}', '\u{1F525}', '\u{1F602}', '\u{1F60D}', '\u{1F44F}', '\u{1F389}', '\u{1F48B}', '\u{1F31F}'];

export const tagOptions = ['chill', 'flirty', 'games', 'music', 'late-night', 'deep-talks', 'fun', 'spicy', 'dare', 'hot-seat'];
